import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../../servicios/api.service';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-agenda-actividades',
  templateUrl: './agenda-actividades.component.html'
})
export class AgendaActividadesComponent implements OnInit {

  public fechas;
  public actividades;
  public fechaActual;

  public idComisiones;
  public legislatura: any = {};
  public legislaturas: any[];
  public periodo: any = {};
  public periodos: any[];
  public sesionesComisionPermanente: any[] = [];
  public mostrarSesionesPermanentes: boolean = false;
  public idSesion; 

  constructor(private _api: ApiService, private datePipe: DatePipe, private _router: ActivatedRoute) {
    this._router.params.subscribe(res => this.idComisiones = res.idComisiones);
  }

  ngOnInit() {
    this.fechas = {
      // inicio: moment().subtract(15, 'days').format('YYYY-MM-DD'),
      // fin: moment().add(15, 'days').format('YYYY-MM-DD')
      inicio: moment().subtract(8, 'days').format('YYYY-MM-DD'),
      fin: moment().add(8, 'days').format('YYYY-MM-DD'),
      /* this.id = */
    }
    this.obtenerAgenda();
    this.fechaActual = moment().format('DD/MM/YYYY');
  }

  public obtenerAgenda() {
    this._api.get(`actividades/${this.fechas.inicio}/${this.fechas.fin}`).subscribe(res => {
      this.actividades = this._api.reader.read(res, []);
      this.formatDates();
      console.log(this.actividades);
    })
  }

  public formatDates() {
    this.actividades.forEach(actividad => {
      actividad.fecha = actividad.fecha && actividad.fecha != '0000-00-00' ? this.datePipe.transform(actividad.fecha, 'dd/MM/yyyy') : '';
      actividad.hora_inicial = moment(actividad.hora_inicial, 'HH:mm:ss').format('hh:mm A')
    })
  }

  //****** */
  //GENERA LINK
  //****** */
  public legislaturaActual() {
    this._api.get(`gpLegislaturaActual`).subscribe(response => {
      let actualLegislatura = this._api.reader.read(response, [{}])[0];
      this.legislatura = actualLegislatura.legislatura;
      this.periodoActual();
      this.traePeriodos(actualLegislatura);
    });
  }

  public periodoActual() {
    this._api.get('gpPeriodoActual').subscribe(res => {
      let actualPeriodo = this._api.reader.read(res, [{}])[0];
      this.periodo = actualPeriodo.periodo;
      this.traeOrden(actualPeriodo);
    })
  }

  public obtenerLegislaturas() {
    this._api.get(`gpLegislaturas`).subscribe(response => {
      this.legislaturas = this._api.reader.read(response, []);
    })
  }

  traePeriodos(legislatura) {
    this.periodos = [];
    this.periodo = {};
    this._api.get(`gpPeriodos/${legislatura.idLegis}`).subscribe(response => {
      this.periodos = this._api.reader.read(response, []);
    })
  }

  traeOrden(periodo) {
    this._api.get(`gpSesionComision/${this.idComisiones}/${periodo.idLegislatura}/${periodo.idPeriodos}`).subscribe(res => {
      this.sesionesComisionPermanente = this._api.reader.read(res);
      if (this.sesionesComisionPermanente.length > 0) {
        this.mostrarSesionesPermanentes = true;
      } else {
        this.mostrarSesionesPermanentes = false;
      }
      this.periodo = periodo;
    })
  }

}